module.exports = __webpack_public_path__ + "static/media/ig_logo.0e84d592.png";